<template>
    <div class="-my-2 sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow border-b border-gray-200 sm:rounded-lg">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                    <tr>
                        <table-head display="Wire Date" key-name="created_at" :sort-key="sortKey" :sort-order="sortOrder" />
                        <table-head display="Reference Number" key-name="id" :sort-key="sortKey" :sort-order="sortOrder"  />
                        <table-head display="Bank Account Number" key-name="account" :sort-key="sortKey" :sort-order="sortOrder"  />
                        <table-head display="Wire Method" key-name="method" :sort-key="sortKey" :sort-order="sortOrder"  />
                        <table-head display="Wire Amount" key-name="amount" :sort-key="sortKey" :sort-order="sortOrder"  />
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in sortedItems" class="border-b border-gray-100">
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                            {{ item.created_at | niceTimestamp }}
                        </td>
                        <td class="px-6 py-4 text-gray-800 text-sm">
                            {{ item.id }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {{ item.account }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {{ item.method }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap text-sm">
                            ${{ item.amount | currency }}
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="wires.length === 0" class="text-center text-gray-400 text-lg p-8">No current items...</div>
            </div>
        </div>
    </div>
</template>

<script>
import TableHead from "@/Components/DataTable/TableHead";

export default {
    components: {TableHead},
    props: {
        wires: {
            type: Array,
            required: true,
            defualt: []
        }
    },
    data() {
        return {
            filteredItems: [],
            showFilter: false,
            sortKey: 'created_at',
            sortOrder: 'desc',
            searchOptions: {},
        }
    },
    mounted() {
        this.filteredItems = this.wires
        this.$eventBus.$on('sortBy', (keyName) => {
            this.sortBy(keyName)
        })
    },
    methods: {
        sortBy(key) {
            this.sortKey = key
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        },
        compareValues(key, order = 'asc') {
            return function innerSort(a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) return 0;
                const comparison = a[key].toString().localeCompare(b[key], undefined, {numeric: true});
                return (
                    (order === 'desc') ? (comparison * -1) : comparison
                );
            };
        }
    },
    computed: {
        sortedItems() {
            return this.wires.sort(
                this.compareValues(this.sortKey, this.sortOrder)
            )
        }
    },
}
</script>
